
$('.ingrd-slider').slick({
  slidesToShow: 2,
  infinite: true,
  dots:true,
  arrows: false,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4510,
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
    }}]
});

$('.feat-slider').slick({
  slidesToShow: 1,
  infinite: true,
  dots:false,
  arrows: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4510,
});

$('.blog-slider').slick({
  slidesToShow: 1,
  infinite: true,
  dots:false,
  arrows: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4510,
});

$('.birdtype-slider').slick({
  slidesToShow: 6,
  infinite: true,
  dots:false,
  arrows: true,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4510,
  responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 3,
      }},
              {
      breakpoint: 765,
      settings: {
        slidesToShow: 1,
      }}]
});
// End

// let ufo = document.querySelector('.sec-2');
// if(ufo){
//   ufo.addEventListener('mousemove', (e) => {
//     let eyes = document.querySelector('.eyes');
//     let mouseX = (eyes.getBoundingClientRect().left); 
//     let mouseY = (eyes.getBoundingClientRect().top);
//     let radianDegrees = Math.atan2(e.pageX - mouseX, e.pageY - mouseY);
//     let rotationDegrees = (radianDegrees * (180/ Math.PI) * -1) + 180;
//     eyes.style.transform = `rotate(${rotationDegrees}deg)`
//   });
// }

var shrinkHeader = 135;
$(window).scroll(function() {
var scroll = getCurrentScroll();
  if ( scroll >= shrinkHeader ) {
	   $('header.header').addClass('fixed');}
	else {
		$('header.header').removeClass('fixed');}});
function getCurrentScroll() {
return window.pageYOffset;
}


// Return To top
$(window).scroll(function() {
    if ($(this).scrollTop() >= 50) {        
        $('#return-to-top').fadeIn(200);    
    } else {
        $('#return-to-top').fadeOut(200);   
}
});
$('#return-to-top').click(function() {      
    $('body,html').animate({
        scrollTop : 0                       
    }, 500);
});

// End


// AOS animation
$(document).ready(function(){

AOS.init({
      offset: 200,
      duration: 600,
      easing: 'ease-in-sine',
      delay: 100,
      disable: 'mobile',
    });
// End



// Mobile Menu

  $('a#hamburg').on('click',function(e){
        $('html').toggleClass('open-menu');
        return false;
    });
    $('div#hamburg').on('click',function(){
        $('html').removeClass('open-menu');
    });
// End


  $('#BlogTagFilter').change(function(){
    window.location.href =$(this).val();
  })
  
  
// WOW animation

var wow = new WOW(
  {
    boxClass:     'wow',      // animated element css class (default is wow)
    animateClass: 'animated', // animation css class (default is animated)
    offset:       0,          // distance to the element when triggering the animation (default is 0)
    mobile:       true,       // trigger animations on mobile devices (default is true)
    live:         true,       // act on asynchronously loaded content (default is true)
    callback:     function(box) {
      // the callback is fired every time an animation is started
      // the argument that is passed in is the DOM node being animated
    },
    scrollContainer: null // optional scroll container selector, otherwise use window
  }
);
wow.init();

// End
});

 $('.product-single__thumbnails-slider-track').slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
    });
$('.product-single__thumbnails-slider-track .slick-prev').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 14 14"><path d="M10.129.604a1.125 1.125 0 0 0-1.591 0L3.023 6.12s.049-.049-.003.004l-.082.08c-.439.44-.44 1.153 0 1.592l5.6 5.6a1.125 1.125 0 0 0 1.59-1.59L5.325 7l4.805-4.805c.44-.439.44-1.151 0-1.59z" fill="#000"></path></svg>');
$('.product-single__thumbnails-slider-track .slick-next').append('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#000"></path></svg>');


$(document).ready(function(){

  // product grid ATC
  $('.card-grid_btn .product-form__cart-submit').click(function(e) {
      e.preventDefault();
      var get_form = $(this).parents('form').attr('id')
      if(!$(this).is(':disabled')){
      let formData = new FormData(document.querySelector('.card-grid_btn #'+get_form));
        fetch('/cart/add.js',{
          method: 'POST',
          headers: {'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(response => response.json())
        .then((response) => {
          $('.cart-popup-wrapper [data-cart-popup-image-wrapper]').html('<img src="'+response.image+'" alt="'+response.product_title+'" class="cart-popup-item__image" data-cart-popup-image="">')
          $('.cart-popup-wrapper [data-cart-popup-title]').text(response.product_title);
          $('.cart-popup-wrapper [data-cart-popup-quantity]').text(1);
          $('.cart-popup-wrapper [data-cart-popup-cart-quantity]').text(response.quantity);
          if(!response.product_has_only_default_variant){
            var variantHTML = '';
            response.options_with_values.forEach(function(variantOption) {
              variantHTML = variantHTML +'<li class="product-details__item product-details__item--variant-option">' +variantOption.name +': ' +variantOption.value +'</li>';
            });
            $('.cart-popup-wrapper [data-cart-popup-product-details]').html(variantHTML);
          }
          $('.cart-popup-wrapper [data-cart-popup-image-wrapper]').removeAttr('data-image-loading-animation').removeClass('hide');
          fetch('/cart.js').then(response => response.json())
          .then((cart) => {
            
            $('.cart-popup-wrapper [data-cart-popup-cart-quantity]').text(cart.item_count);
            $('#CartCount').removeClass('hide');
            $('#CartCount [data-cart-count]').text(cart.item_count)
          });
          $('.cart-popup-wrapper').addClass('is-transitioning').addClass('active')
          setTimeout(function(){$('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden').removeClass('is-transitioning')},200)
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
  });
  
  $(document).on('click','.cart-popup-wrapper.active [data-cart-popup-close],.cart-popup-wrapper.active [data-cart-popup-dismiss]',function (e) {
    e.preventDefault();
    $('.cart-popup-wrapper').addClass('is-transitioning').addClass('cart-popup-wrapper--hidden');
    setTimeout(function(){$('.cart-popup-wrapper').removeClass('active').removeClass('is-transitioning')},200)
  });
  
});